import React, { useState } from "react";
import BasicInfo from "./sections/BasicInfo/BasicInfo";
import RequirementInfo from "./sections/RequirementInfo/RequirementInfo";
import JobDescription from "./sections/JobDescription/JobDescription";
import ModeOfRequirement from "./sections/ModeOfRequirement/ModeOfRequirement";
import Terms from "./sections/Terms/Terms";
import Notes from "./sections/Notes/Notes";
import { axios } from "../../../../../../../Global";
import { CgSpinner } from "react-icons/cg";
import { setAppError } from "../../../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";

export default function JobEnquiryCreate() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const nationality_data = location.state;
  const [data, setData] = useState({});
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  console.log(nationality_data, "location");

  const toggleJobEnquiryUpdate = useOutletContext()[1];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (data?.v_benefit == "YES" && data?.v_benefit_value == "") {
      setLoading(false);
      dispatch(setAppError({ msg: "Provide visa benefit cost" }));
      return;
    }
    if (data?.v_cost == "YES" && data?.v_cost_value == "") {
      setLoading(false);
      dispatch(setAppError({ msg: "Provide visa  cost" }));
      return;
    }
    if (String(data?.nationality_id)?.trim() == "") {
      setLoading(false);
      dispatch(setAppError({ msg: "Please select a nationality" }));
      return;
    }
    if (data?.notes?.length == 0) {
      setLoading(false);
      dispatch(setAppError({ msg: "Atleast one note is needed." }));
      return;
    }
    if (data?.terms_and_conditions?.length == 0) {
      setLoading(false);
      dispatch(
        setAppError({ msg: "Atleast one terms and conditions is needed." })
      );
      return;
    }
    if (data?.v_benefit == "NO") delete data?.v_benefit_value;
    if (data?.v_cost == "NO") delete data?.v_cost_value;

    try {
      const res = await axios.post(`/dashboard/project-job-enquiry`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.status == 200) {
        setLoading(false);
        toggleJobEnquiryUpdate();
        dispatch(setAppError({ msg: res.data.message, color: "success" }));
        navigate(-1);
      }
    } catch (error) {
      dispatch(
        setAppError({ msg: error?.response?.data?.message || error?.message })
      );
      setLoading(false);
    }
  };
  console.log(data, "data");
  return (
    <>
      <div className="w-full flex flex-wrap gap-4 justify-between items-center p-5 ">
        <div className="flex gap-16">
          <h1 className="font-semibold text-xl">Job Enquiry Creation</h1>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="w-full flex flex-col gap-7">
          <BasicInfo setData={setData} nationality_data={nationality_data} />
          <RequirementInfo
            setData={setData}
            vBenefit={data?.v_benefit}
            vBenefitValue={data?.v_benefit_value}
          />
          <JobDescription setData={setData} />
          <ModeOfRequirement setData={setData} />
          <Terms setData={setData} />
          <Notes setData={setData} />
        </div>
        <div className="w-full p-4 mt-6 flex justify-end gap-4">
          <button
            type="button"
            className="p-2 px-6 ring-1 ring-slate-200 rounded-md"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
          <button
            className="p-2 px-6 ring-1 ring-slate-200 rounded-md bg-red text-white"
            type="submit"
            disabled={loading}
          >
            {loading ? <CgSpinner className="animate-spin" /> : "Submit"}
          </button>
        </div>
      </form>
    </>
  );
}
